import { Skeleton } from "@/components/ui/skeleton";

export function UnloadViewSkeleton() {
  return (
    <div className="flex h-full flex-col gap-3">
      <Skeleton className="h-12 w-full" />
      <Skeleton className="w-full grow" />
      <Skeleton className="h-16 w-full" />
    </div>
  );
}
